import React, { useContext, useEffect, useState } from 'react';
import { getTerms, createTerms, updateTerms, deleteTerms } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css'
import  EditTerms  from './Form';
import { Deletemodel, Pagination } from "../../Common/Functions"
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';
import { useLocation } from 'react-router-dom';

const Termsandconditions = () => {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const [terms, setTerms] = useState([]);
    const [formData, setFormData] = useState({ 
        content: '', 
        status: '',
        remark: '',
        applicableFor: '' // purchase/quotation/sales
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedTerm, setSelectedTerm] = useState(null);
    const [addoredit, setaddoredit] = useState();
    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const termsPerPage = 10;

    

    useEffect(() => {
        fetchTerms();
    }, []);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    }

    const fetchTerms = async (page = currentPage, text = "") => {
        showLoader();
        try {
            const response = await getTerms(page, text);
            if (response.data && response.data.data) {
                setTerms(response.data.data);
                setTotalPages(response.data.pagination.total_pages);
            }
        } catch (error) {
            console.error('Error fetching terms data:', error);
        } finally {
            hideLoader();
        }
    };
    

    const openAddModal = () => {
        setaddoredit(true);
        setFormData({
            shop_id:'',
            terms: '', 
            status: '1',
            remark: '',
            type: 'purchase' // default
        });
        setShowEditModal(true);
    };

    const openEditModal = (term) => {
        setSelectedTerm(term);
        setaddoredit(false);
        setFormData({
            shop_id:term.shop_id,
            terms: term.terms,
            status: term.status,
            remark: term.remark,
            type: term.type
        });
        setShowEditModal(true);
    };

    // Delete a term
    const handleDelete = async () => {
        try {
            await deleteTerms(deleteID);
            showDeletemodel(false);
            toast.error('Term deleted successfully');
            fetchTerms(currentPage);
        } catch (error) {
            console.error('Error deleting term:', error);
            toast.error('Error deleting term');
        }
    };

    // Pagination logic
    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchTerms(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchTerms(1, text);
    };

    const activateTerm = async (value) => {
        showLoader();
        try {
            const payload = {
                ...value,
                status: value.status === '1' ? '0' : '1',
            };
            const res = await updateTerms(value.id, payload);
            hideLoader();
            await fetchTerms(currentPage);
            toast.success(`Term ${payload.status === '1' ? 'activated' : 'deactivated'}`);
        } catch (err) {
            console.error(err);
            toast.error(err.message);
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Terms and Conditions</h6>
                       {!readonly && <button
                        type="button"
                        onClick={() => openAddModal()}
                        className="btn btn-primary mb-0 text-normal rounded-1"
                    >
                        Add Terms
                    </button>}
                </div>
                <hr className='mt-1' />

                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table
                                id="example"
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        {/* <th>Shop ID</th> */}
                                        <th>Invoice Type</th>
                                        <th>Terms & conditions</th>
                                        <th>Remark</th>
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {terms.map((term, index) => (
                                        <tr key={term.id}>
                                            <td>{(currentPage - 1) * termsPerPage + index + 1}</td>
                                            <td>{term.type}</td>
                                            <td style={{
                                                        maxHeight: '100px',
                                                        overflowY: 'auto',
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                        padding: '8px',
                                                        }}>
                                                        {term.terms}
                                                        </td>

                                                        <td style={{
                                                        maxHeight: '100px',
                                                        overflowY: 'auto',
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                        padding: '8px',
                                                        }}>
                                                        {term.remark}
                                                        </td>

                                             <td>
                                                        <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(term)} height="16px" alt="Edit" />
                                                        &nbsp;&nbsp;&nbsp;
                                                        {/* <img src='/assets/images/icons/delete.png' className="mx" onClick={() => handledeletemodel(term.id)} height="16px" alt="Delete" /> */}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}
            <EditTerms 
                showModal={showEditModal} 
                setShowModal={setShowEditModal} 
                fetchTerms={fetchTerms} 
                selectedTerm={selectedTerm} 
                AddorEdit={addoredit} 
                formData={formData}
                setFormData={setFormData}
            />
        </div>
    )
}




export default Termsandconditions;